export class DateTimeHelper {
    public static isoToLocalStr(src: string, separator: string = '-'): string {
        const srcDate = new Date(src);
        const year = srcDate.getFullYear();
        const month = srcDate.toLocaleDateString('en-US', { month: '2-digit' });
        const time = srcDate.toLocaleTimeString('en-US', { hour12: false, timeStyle: 'short' } as any);

        return `${year}${separator}${month}${separator}${srcDate.getDate()} ${time}`;
    }

    public static getLocalDate(src: string | Date, separator: string = '-'): string {
        const srcDate: Date = src instanceof Date ? src : new Date(src);
        const year = srcDate.getFullYear();
        const month = srcDate.toLocaleDateString('en-US', { month: '2-digit' });
        const date = srcDate.toLocaleDateString('en-US', { day: '2-digit' });

        return `${year}${separator}${month}${separator}${date}`;
    }

    public static getLocalTime(src: string | Date): string {
        const srcDate: Date = src instanceof Date ? src : new Date(src);
        // return srcDate.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }).slice(0, 5);
        return srcDate.toLocaleTimeString('nl-BE', { hour: '2-digit', minute: '2-digit' });
    }

    public static parseDate(src: string | Date): {year: number, month: number, date: number, hours: number, minutes: number, seconds: number} {
        const srcDate: Date = src instanceof Date ? src : new Date(src);
        return {
            year: srcDate.getFullYear(),
            month: srcDate.getMonth(),
            date: srcDate.getDate(),
            hours: srcDate.getHours(),
            minutes: srcDate.getMinutes(),
            seconds: srcDate.getSeconds(),
        }
    }
}
